import React from 'react';
import { useSelector } from 'react-redux';
import { ActionButton, Flex, Grid, ToggleButton, View, } from '@adobe/react-spectrum';
import Close from '@spectrum-icons/workflow/Close';
import { EditorActions } from 'app/stores/editor/actions';
import { getActiveTool } from 'app/stores/selectors';
import { useAppDispatch } from 'app/stores/store';
import { getToolIcon, ToolIcon, } from 'app/views/components/editor/pickers/ToolIcon';
import { Text } from 'app/views/components/typography/Text';
import { useConnect } from 'app/views/hooks/useConnect';
import { analytics } from 'app/utils/analytics';
import { call } from 'app/utils/function';
const ToolButtons = (props) => {
    const { onSelect } = props;
    const dispatch = useAppDispatch();
    const { tools, activeTool } = useConnect(state => ({
        tools: state.editor.availableTools,
        activeTool: getActiveTool(state),
    }));
    const onAction = React.useCallback((toolId, toolAlias) => {
        if (toolId) {
            if ((activeTool === null || activeTool === void 0 ? void 0 : activeTool.id) !== toolId) {
                analytics({
                    action: 'ToolPicker',
                    label: `select:${toolAlias}`,
                });
                dispatch(EditorActions.setActiveTool(toolId));
            }
        }
        else {
            analytics({
                action: 'ToolPicker',
                label: 'select:clear',
            });
            dispatch(EditorActions.clearTool());
        }
        call(onSelect);
    }, [activeTool, onSelect, dispatch]);
    // const showCropper = React.useCallback(() => {
    //     analytics({
    //         action: 'ToolPicker',
    //         label: 'selectImageCrop',
    //     });
    //     dispatch(EditorActions.showImageCropper());
    //     call(onSelect);
    // }, [onSelect, dispatch]);
    const colsCount = 3;
    const rowsCount = Math.ceil(tools.length / colsCount);
    const slotsCount = colsCount * rowsCount;
    const emptySlotsCount = slotsCount - tools.length;
    const areas = new Array(emptySlotsCount)
        .fill('.')
        .concat(tools.map(tool => tool.id))
        .reduce((rows, item, index) => {
        rows[Math.floor(index / colsCount)].push(item);
        return rows;
    }, new Array(rowsCount).fill(null).map(() => []))
        .map(row => row.join(' '));
    return (React.createElement(View, { UNSAFE_className: "tool-picker", position: "absolute", padding: "size-50", backgroundColor: "gray-200", borderColor: "gray-400", borderWidth: "thin", bottom: "105%", right: -10 },
        React.createElement(Grid, { areas: areas, columns: ['size-600', 'size-600', 'size-600'], autoRows: "size-600", justifyContent: "center", gap: "size-50" }, tools.map(tool => (React.createElement(ToggleButton, { key: tool.id, gridArea: tool.id, isSelected: tool.id === (activeTool === null || activeTool === void 0 ? void 0 : activeTool.id), onPress: () => onAction(tool.id, tool.alias), marginBottom: "size-75", height: "auto", isQuiet: true },
            React.createElement(Flex, { width: "100%", direction: "column", alignItems: "center", margin: "size-10" },
                React.createElement(ToolIcon, { tool: tool }))))))));
};
export const ToolPicker = () => {
    const [open, setOpen] = React.useState(false);
    const activeTool = useSelector((state) => state.editor.availableTools.filter(tool => tool.id === state.editor.activeTool)[0]);
    const Icon = (open ? Close : getToolIcon(activeTool));
    return (React.createElement("div", { style: { position: 'relative' } },
        open && React.createElement(ToolButtons, { onSelect: () => setOpen(false) }),
        React.createElement(ActionButton, { onPress: () => setOpen(!open) }, activeTool &&
            (Icon ? (React.createElement(Icon, null)) : (React.createElement(Text, { size: "XS", tag: "p" }, activeTool.alias))))));
};
